export interface ExpandedImageItem {
  src: string;
  name: string;
}

export interface ExpandedImagePreview {
  images: ExpandedImageItem[];
  index: number;
}

/**
 * The carousel for a clicked image.
 *
 * Non-image attachments are dropped here rather than at each call site: a
 * staged file carries an object URL for its download link exactly like an image
 * carries one for its thumbnail, so "has a previewUrl" stopped being the same
 * question as "can be shown". Missing that turns the arrow keys into a tour of
 * blank frames.
 */
export function buildExpandedImagePreview(
  images: ReadonlyArray<{
    id: string;
    name: string;
    previewUrl?: string;
    type?: "image" | "file";
  }>,
  selectedImageId: string,
): ExpandedImagePreview | null {
  const previewableImages = images.flatMap((image) =>
    image.previewUrl && image.type !== "file"
      ? [{ id: image.id, src: image.previewUrl, name: image.name }]
      : [],
  );
  if (previewableImages.length === 0) {
    return null;
  }
  const selectedIndex = previewableImages.findIndex((image) => image.id === selectedImageId);
  if (selectedIndex < 0) {
    return null;
  }
  return {
    images: previewableImages.map((image) => ({
      src: image.src,
      name: image.name,
    })),
    index: selectedIndex,
  };
}
